module.exports = __webpack_public_path__ + "static/media/shopify-bag-icon.513a3674.png";